/**
 * OPS-TENANT-GOVERNANCE-IDENTITY-001 — tenant-scoped uriId helpers for governance registries and UI.
 */

export const TEMPLATE_APPS_CODE = 'FONE';

export function extractAppsPrefix(identifier) {
  if (!identifier || typeof identifier !== 'string') {
    return '';
  }
  const trimmed = identifier.trim();
  const colon = trimmed.indexOf(':');
  return colon > 0 ? trimmed.slice(0, colon) : '';
}

export function extractUriSuffix(identifier) {
  if (!identifier || typeof identifier !== 'string') {
    return '';
  }
  const trimmed = identifier.trim();
  const colon = trimmed.indexOf(':');
  return colon >= 0 ? trimmed.slice(colon + 1).trim() : trimmed;
}

export function tenantUriId(appsCode, suffix) {
  const code = appsCode?.trim();
  const suf = suffix?.trim();
  if (!code || !suf) {
    throw new Error('tenantUriId requires appsCode and suffix');
  }
  return `${code.toUpperCase()}:${suf.toUpperCase()}`;
}

export function replaceTemplatePrefix(appsCode, identifier) {
  if (!identifier || !appsCode) {
    return identifier;
  }
  const prefix = extractAppsPrefix(identifier);
  if (prefix === TEMPLATE_APPS_CODE) {
    return tenantUriId(appsCode, extractUriSuffix(identifier));
  }
  return identifier;
}

export function resolveRegistryUriId(registryUriId, appsCode) {
  return tenantUriId(appsCode, extractUriSuffix(registryUriId));
}

export function resolveRegistryPermissionKeys(keys, appsCode) {
  if (!Array.isArray(keys)) {
    return [];
  }
  return keys.map((key) => tenantUriId(appsCode, extractUriSuffix(key)));
}

export function assertTenantOwned(appsCode, identifier) {
  const prefix = extractAppsPrefix(identifier);
  if (!prefix || !appsCode) {
    return;
  }
  if (prefix.toUpperCase() !== String(appsCode).trim().toUpperCase()) {
    throw new Error(
      `Identifier '${identifier}' belongs to tenant '${prefix}' but target is '${appsCode}'`,
    );
  }
}
